module.exports = __webpack_public_path__ + "static/media/InkFree.d2a630e3.woff2";